const PURCHASED_DIGITAL_BUNDLE_STATUS = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
};

const DIGITAL_BUNDLE_SIZES = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];

export { PURCHASED_DIGITAL_BUNDLE_STATUS, DIGITAL_BUNDLE_SIZES };
